export const getIsContractSymbol = (symbol: string): boolean =>
  symbol.length > 12;
